import React, { useState, useEffect } from 'react';
import { Volume2, VolumeX } from 'lucide-react';
import { useStore } from '../store';

const AudioControls = () => {
  const [isMuted, setIsMuted] = useState(false);
  const isAnimating = useStore((state) => state.isAnimating);
  const audio = useStore((state) => state.audio);

  // Use a direct DOM approach to ensure iOS Safari compatibility
  const setupButtonEvents = (buttonElement) => {
    if (!buttonElement) return;
    
    // Add these attributes directly to the DOM element for iOS Safari
    buttonElement.setAttribute('role', 'button');
    buttonElement.style.cursor = 'pointer';
    
    // Add a no-op listener to ensure iOS Safari registers it as clickable
    buttonElement.addEventListener('click', () => {}, { passive: false });
    
    // Add the actual handlers with different events for maximum compatibility
    const toggleAudio = () => {
      if (!audio) return;
      
      const newMutedState = !isMuted;
      setIsMuted(newMutedState);
      
      try {
        if (newMutedState) {
          audio.volume = 0;
        } else {
          audio.volume = 0.5;
        }
      } catch (error) {
        console.error('Error updating audio volume:', error);
      }
    };
    
    buttonElement.addEventListener('click', toggleAudio, { passive: false });
    buttonElement.addEventListener('touchend', (e) => {
      e.preventDefault();
      e.stopPropagation();
      toggleAudio();
    }, { passive: false });
  };

  // If audio state changes externally, update the UI
  useEffect(() => {
    if (!audio) return;
    
    try {
      if (isMuted) {
        audio.volume = 0;
      } else {
        audio.volume = 0.5;
      }
    } catch (error) {
      console.error('Error synchronizing audio volume:', error);
    }
  }, [isMuted, audio]);

  // Only show controls if we're in the animated state (after clicking enter)
  if (isAnimating && audio) {
    return (
      <div className="absolute top-[1%] right-[2%] z-[10] transition-opacity duration-500">
        <button 
          ref={setupButtonEvents}
          className="text-white/70 hover:text-white transition-colors cursor-pointer p-6"
          style={{ 
            WebkitTapHighlightColor: 'transparent'
          }}
          aria-label={isMuted ? "Unmute audio" : "Mute audio"}
        >
          {isMuted ? 
            <VolumeX size={36} /> : 
            <Volume2 size={36} />
          }
        </button>
      </div>
    );
  }

  return null;
};

export default AudioControls;